const BASE = process.env.REACT_APP_API_URL || '/api';

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const api = {
  // People
  getPeople: () => req('GET', '/people'),
  addPerson: (data) => req('POST', '/people', data),
  deletePerson: (id) => req('DELETE', `/people/${id}`),

  // Groups
  getGroups: () => req('GET', '/groups'),
  addGroup: (data) => req('POST', '/groups', data),
  deleteGroup: (id) => req('DELETE', `/groups/${id}`),

  // Expenses
  getExpenses: (groupId) => req('GET', `/expenses${groupId ? `?group_id=${groupId}` : ''}`),
  addExpense: (data) => req('POST', '/expenses', data),
  deleteExpense: (id) => req('DELETE', `/expenses/${id}`),

  // Settlements
  getSettlements: () => req('GET', '/settlements'),
  addSettlement: (data) => req('POST', '/settlements', data),

  // Balances
  getBalances: () => req('GET', '/balances'),
};
